import {
  resolveImageURL,
  isYouTubeUrl,
} from '../../../helpers/multimediaUtils';
import PageHeaderSimple from '../../Molecules/PageHeaderSimple';
import {
  ContentNarrow,
  ContentWide,
  ContentWrapper,
  PageSection,
} from 'volto-essvoltocomponents/components/Layout';
import { ESSButton } from '../../Atoms/ESSButton';
import YouTubePlayer from '../../Atoms/YouTubePlayer';
import RichText from '../../Atoms/RichText';
import PDFJSViewer from '../../Atoms/PDFJSViewer';
import './ResourceView.scss';

const ResourceView = ({ content }) => {
  const title = content.title;
  const externalUrl = content.url; //zope.schema.URI that volto receives as plain string
  const heroImageUrl =
    content?.inline_image &&
    resolveImageURL(content, '/@@images/inline_image/larger');
  const heroVideoUrl = content.inline_iframe;
  const body = content.body?.data; //richtext
  const pdfUrl = content.inline_pdf;
  return (
    <>
      <PageHeaderSimple
        title={title}
        description={
          content?.full_description?.data || content?.description || ''
        }
        showBackButton={true}
        goBackText="Go back"
        variant="minimal"
      />
      <PageSection
        paddingTop="var(--ess-space-2xl)"
        paddingBottom="var(--ess-space-2xl)"
      >
        {/* External URL */}
        {externalUrl && (
          <ContentWrapper>
            <ContentWide className="multimedia-item-external-url">
              Website:
              <ESSButton
                variant="link-icon"
                size="lg"
                onClick={() => {
                  if (typeof window !== 'undefined')
                    window.location.href = { externalUrl };
                }}
              >
                {externalUrl}
              </ESSButton>
            </ContentWide>
          </ContentWrapper>
        )}

        {/* Image */}
        {heroImageUrl && (
          <ContentWrapper>
            <ContentWide>
              <img
                src={heroImageUrl}
                alt={title || ''}
                loading="lazy"
                className="multimedia-item-hero-image"
              />
            </ContentWide>
          </ContentWrapper>
        )}

        {/* Video */}
        {heroVideoUrl && (
          <ContentWrapper>
            <ContentWide>
              {isYouTubeUrl(heroVideoUrl) ? (
                <YouTubePlayer
                  url={heroVideoUrl}
                  aspectRatio="16/9"
                  className="multimedia-item-hero-video"
                />
              ) : (
                <div className="multimedia-item-hero-video">
                  <iframe
                    src={heroVideoUrl}
                    title={title || 'Embedded video'}
                    width="100%"
                    height="480"
                    style={{ border: 0 }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
              )}
            </ContentWide>
          </ContentWrapper>
        )}

        {/* PDF */}
        {pdfUrl && (
          <ContentWrapper>
            <ContentWide>
              {PDFJSViewer ? (
                <PDFJSViewer
                  url={pdfUrl}
                  downloadFilename={title ? `${title}.pdf` : undefined}
                />
              ) : (
                <div>Loading PDF viewer...</div>
              )}
            </ContentWide>
          </ContentWrapper>
        )}

        {/* Body */}
        {body && (
          <ContentWrapper paddingBottom="0">
            <ContentWide>
              <ContentNarrow>
                <RichText content={body} className="multimedia-item-body" />
              </ContentNarrow>
            </ContentWide>
          </ContentWrapper>
        )}
      </PageSection>
    </>
  );
};

export default ResourceView;
